// extracted by mini-css-extract-plugin
module.exports = {"noAssociationsContainer":"noAssociationsPlaceholder_noAssociationsContainer__DR7mL","noAssociationsFoundText":"noAssociationsPlaceholder_noAssociationsFoundText__3TD5s"};